module.exports = __webpack_public_path__ + "static/media/top-slide-2.8221853c.avif";